"use client";

/**
 * SectionSkeleton — loading placeholder for dynamic-imported sections.
 * Matches section-pad height with a subtle shimmer animation.
 * Prevents layout shift while JS chunks load.
 */
export default function SectionSkeleton() {
  return (
    <div className="section-pad flex flex-col items-center justify-center gap-4" aria-hidden>
      {/* Shimmer bar mimicking an eyebrow */}
      <div className="shimmer h-3 w-24 rounded-full" />
      {/* Shimmer bar mimicking a heading */}
      <div className="shimmer h-6 w-64 rounded-lg" />
      {/* Shimmer bar mimicking body text */}
      <div className="shimmer h-4 w-48 rounded-lg" />
    </div>
  );
}
